import { CapinetInitialState } from './initialize';
import { RESET, SET_ATTACHMENTS, SET_FORM, SET_STEP, SET_TOKEN, SET_TYPE } from './types';

export default (state, action) => {
  switch (action.type) {
    case SET_FORM: {
      return { ...state, form: { ...state.form, ...action.payload } };
    }
    case SET_STEP: {
      return { ...state, step: action.payload };
    }
    case SET_TOKEN: {
      return { ...state, token: action.payload };
    }
    case SET_ATTACHMENTS: {
      return { ...state, attachments: { ...state.attachments, ...action.payload } };
    }
    case SET_TYPE: {
      return { ...state, form: { ...state.form, clientType: action.payload } };
    }

    case RESET: {
      return CapinetInitialState;
    }
    default:
      return state;
  }
};
